import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import moment from "moment";

import { createAxiosInstance } from "api/axiosConfig";

const toFormMedicine = (medication) => ({
  id: medication.id,
  dosage: medication.dosage || "",
  form: medication.form || "",
  startDate: moment(medication.startDate).format("DD-MM-YYYY"),
  finishDate: moment(medication.finishDate).format("DD-MM-YYYY"),
  duration: medication.duration || "",
  durationFormat: medication.durationFormat || "",
  usageType: medication.acuteLongTerm || "",
  repeat: medication.repeat || "",
  tradeName: medication.tradeName || "",
  manufacturer: medication.manufacturer || "",
  packSize: medication.pack || "",
  medicineId: medication.medicationId || "",
  route: medication.route || "",
  frequency: medication.frequency || "",
  isManual: !medication.medicationId,
  quantity: medication.quantity || "",
});

export const useActiveConsultationPrescription = (consultationId) => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  const query = useQuery({
    queryKey: ["activeConsultationPrescription", tenantVal, consultationId],
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/patientprescription/getbyconsultation/${consultationId}`
      );
      return response.data;
    },
    enabled: !!consultationId && !!tenantVal,
    meta: { errorMessage: "Error fetching prescription" },
  });

  const initialData = useMemo(() => {
    const prescriptions = query.data;

    if (!prescriptions) return null;

    const first = prescriptions.at(0) || {};
    const medicines = prescriptions
      .flatMap((p) => p.medications ?? [])
      .map(toFormMedicine);

    return {
      id: first.id,
      instructions: first.note || "",
      filePath: first.filePath,
      medicines,
    };
  }, [query.data]);

  return { ...query, initialData };
};